import React, { Component, PropTypes } from 'react';
import cx from 'classnames'

export class LargeTableLogo extends Component {
  static propTypes = {
    className: PropTypes.string,
    light: PropTypes.bool,
    white: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    return (
       <svg
        className={cx('logo--large', this.props.className, { 'm-light': this.props.light, 'm-white': this.props.white })}
        x={0}
        y={0}
        viewBox='598 -89.7 1440 422.4'
        style={{ enableBackground: 'new 598 -89.7 1440 422.4' }}
      >
        <defs>
          <clipPath id='logo-mask'>
            <polygon points='1018.1,92.4 1018.1,32.3 898.1,32.3 838,32.3 778.1,32.3 718.1,32.3 598,32.3 598,92.4 718.1,92.4
              718.1,332.7 778.1,332.7 778.1,92.4 838,92.4 838,332.7 898.1,332.7 898.1,92.4   '/>
            <path d='M988.1-27.4c16.7,0,30.2-13.6,30.2-30.2s-13.6-30.2-30.2-30.2c-16.7,0-30.2,13.6-30.2,30.2
              S971.4-27.4,988.1-27.4z'/>
            <path d='M1260.4,254.3l-25.1-60.1h-0.1l-67.9-161.9h-65.1l-67.9,161.9h-0.1l-25.2,60.1h0.1l-32.7,78.1l65,0.1
              l32.8-78.2h121l32.8,78.2l65-0.1L1260.4,254.3L1260.4,254.3z M1099.4,194.3l35.3-84.3l35.3,84.3H1099.4z'/>
              <path d='M1547.5,120.8c0-48.8-39.7-88.5-88.5-88.5h-77.7h-60v60v56.9v60v63.3v59.9v0.1h136.2
                c50.5,0,91.6-41.1,91.6-91.7c0-23.7-9-45.3-23.8-61.6C1539.1,163.7,1547.5,143.2,1547.5,120.8z M1381.4,92.3h77.7
                c15.7,0,28.5,12.8,28.5,28.5s-12.8,28.5-28.5,28.5h-1.5h-76.1V92.3z M1457.5,272.5h-76.1v-63.3h76.1c17.4,0,31.6,14.2,31.6,31.6
                C1489.1,258.3,1475,272.5,1457.5,272.5z'/>
            <polygon points='1660.9,32.3 1600.9,32.3 1600.9,272.4 1600.9,332.4 1600.9,332.5 1660.9,332.5 1660.9,332.4
              1798.6,332.4 1798.6,272.4 1660.9,272.4   '/>
            <polygon points='2038,92.4 2038,32.3 1900.4,32.3 1840.3,32.3 1840.3,92.4 1840.3,149.2 1840.3,209.2 1840.3,272.4
              1840.3,332.4 1840.3,332.5 1900.4,332.5 1900.4,332.4 2038,332.4 2038,272.4 1900.4,272.4 1900.4,209.2 2038,209.2 2038,149.2
              1900.4,149.2 1900.4,92.4   '/>
          </clipPath>
        </defs>
        <g>
          <g className='logo-letter-t'>
            <rect x='718.1' y='31.4' className='logo-t1 st5' width='60.1' height='300.4' clipPath='url(#logo-mask)'/>
            <rect x='598' y='31.4' className='logo-t2 st2' width='420.1' height='60.1' clipPath='url(#logo-mask)'/>
            <rect x='838' y='31.4' className='logo-t3 st4' width='60.1' height='300.4' clipPath='url(#logo-mask)'/>
            <path
              className='logo-dot st6'
              d='M988.1-28.3c-16.7,0-30.2-13.6-30.2-30.2s13.6-30.2,30.2-30.2c16.7,0,30.2,13.6,30.2,30.2S1004.8-28.3,988.1-28.3z'
              clipPath='url(#logo-mask)'
            />
          </g>
          <g className='logo-letter-a'>
            <polygon className='logo-a1 st7' points='1041.5,331.6 1167.3,31.4 1102.2,31.4 976.5,331.4' clipPath='url(#logo-mask)'/>
            <polygon className='logo-a2 st0' points='1260.4,253.4 1009.1,253.4 1034.3,193.3 1235.2,193.3' clipPath='url(#logo-mask)'/>
            <polygon className='logo-a3 st2' points='1228.1,331.6 1102.2,31.4 1167.3,31.4 1293.1,331.4' clipPath='url(#logo-mask)'/>
          </g>
          <g className='logo-letter-b'>
            <rect x='1321.4' y='31.3' className='logo-b1 st0' width='60' height='300.1'/>
            <path className='logo-b2 st1' d='M1459,208.3h-137.7v-60H1459c15.7,0,28.5-12.8,28.5-28.5s-12.8-28.5-28.5-28.5h-137.7v-60H1459
              c48.8,0,88.5,39.7,88.5,88.5S1507.8,208.3,1459,208.3z' clipPath='url(#logo-mask)'/>
            <path className='logo-b3 st1' d='M1457.5,331.6h-136.2v-60h136.2c17.4,0,31.6-14.2,31.6-31.6c0-17.4-14.2-31.6-31.6-31.6h-136.2v-60h136.2
              c50.5,0,91.6,41.1,91.6,91.7S1508.1,331.6,1457.5,331.6z' clipPath='url(#logo-mask)'/>
          </g>
          <g className='logo-letter-l'>
            <rect x='1600.9' y='31.4' className='logo-l1 st4' width='60' height='300.2' clipPath='url(#logo-mask)'/>
            <rect x='1600.9' y='271.4' className='logo-l2 st2' width='197.7' height='60' clipPath='url(#logo-mask)'/>
          </g>
          <g className='logo-letter-e'>
            <rect x='1840.3' y='31.4' className='logo-e1 st0' width='60' height='300.2' clipPath='url(#logo-mask)'/>
            <rect x='1840.3' y='31.4' className='logo-e2 st2' width='197.7' height='60' clipPath='url(#logo-mask)'/>
            <rect x='1840.3' y='148.2' className='logo-e3 st3' width='197.7' height='60' clipPath='url(#logo-mask)'/>
            <rect x='1840.3' y='271.4' className='logo-e4 st1' width='197.7' height='60' clipPath='url(#logo-mask)'/>
          </g>
        </g>
      </svg>
    );
  }
}
